module.exports = __webpack_public_path__ + "img/escola_creative_learning_laboratorio.30cca211.jpeg";